export const NAME = 'forgotPassword';